var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectListSorted',{attrs:{"facet":"highlights","operator":"AND","order":"popularity"},scopedSlots:_vm._u([{key:"icon",fn:function(ref){
var value = ref.value;
return [(_vm.getIcon(value))?_c('SvgIcon',{staticClass:"highlight--icon",attrs:{"src":_vm.getIcon(value)}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }